<div *ngIf="isVisible" [class.content]="contentLoader" id="loader" class="loader-wrapper">
    <div id="loader-inner">
        <svg width="100" height="100" xmlns="http://www.w3.org/2000/svg">
            <defs>
                <filter id="halo" filterUnits="userSpaceOnUse" x="0" y="0" width="100" height="100">
                    <feGaussianBlur in="SourceGraphic" stdDeviation="2"></feGaussianBlur>
                </filter>
                <filter id="gooey" filterUnits="userSpaceOnUse" x="0" y="0" width="100" height="100">
                    <feGaussianBlur in="SourceGraphic" result="blur" stdDeviation="3"></feGaussianBlur>
                    <feColorMatrix in="blur" mode="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 18 -7"></feColorMatrix>
                </filter>
            </defs>
            <g filter="url(#gooey)">
                <circle *ngFor="let delay of trailDelays; let i = index"
                        cx="50" cy="20" r="6"
                        class="dot"
                        [style.fill]="getTrailFill(i)"
                        [style.animation-delay.s]="delay">
                </circle>
            </g>
            <circle cx="50" cy="20" r="6"
                    fill="none"
                    stroke="white"
                    stroke-width="4"
                    filter="url(#halo)"
                    class="dot">
            </circle>
            <circle cx="50" cy="20" r="6"
                    fill="var(--primary-color)"
                    class="dot">
            </circle>
        </svg>
    </div>
</div>
